/**
 * PrintPage
 */

import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { useLocation } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Alert, Modal } from 'react-bootstrap';
import { intlBreak } from 'utils/intlFunctions.jsx';
import { useApi2 } from 'containers/Api2/index.js';
import PrintButton from 'components/interaction/PrintButton/index.jsx';
import { idValues } from 'utils/arrays.js';
import EmployeeTemplate from './EmployeeTemplate.jsx';
import StudentTemplate from './StudentTemplate.jsx';
import ParentTemplate from './ParentTemplate.jsx';
import messages from './messages.js';
import adminParser from '../../../adminParser.js';

export const GlobalPrintStyle = createGlobalStyle`
  @media print {
    body.modal-open {
      & > * {
        display: none !important;
      }
      & > div.modal {
        display: block !important;
        position: static !important;
        .modal-content {
          box-shadow: none !important;
          border: none !important;
        }
      }
      .no-print-max-height {
        max-height: none !important;
      }
    }
  }
`;

const Wrapper = styled(Modal)`
  @media print {
    .modal-lg.modal-dialog {
      width: 100%;
    }
    .modal-content {
      border: none;
    }
    .modal-body {
      padding: 0 !important;
    }
  }
  @media screen {
    .modal-body {
      max-height: calc(100vh - 200px);
      overflow-y: auto;
      margin-bottom: 8px;
    }
  }
`;
function PrintPage() {
  const { hash } = useLocation();
  const parts = hash.slice(1).split('/');
  const idList = parts.pop().split(',').map(Number);
  const [print, recipient, subject] = parts;
  const language = print.split('-')[1];
  function fetchOptions() {
    if (subject === 'student') {
      return { url: `sa/users/student/${idList[0]}`, version: 2, parser: adminParser };
    }
    return {
      method: 'POST',
      url: `sa/users/${recipient}/invitations`,
      body: {
        [recipient === 'employee' ? 'users' : 'groups']: idList,
      },
      ignore: [404],
      version: 2,
    };
  }
  const data = useApi2(fetchOptions());
  if (data.loading || data.working || data.error) {
    return null;
  }
  function getUserList() {
    if (!subject) {
      return data.users;
    }
    return recipient === 'parent' ? [{
      studentName: data.displayName,
      groups: idValues(data.administrativeGroups).map((g) => g.name),
      code: data.connectionCodeParent,
    }] : [{
      id: data.id,
      groups: idValues(data.administrativeGroups).map((g) => g.name),
      code: data.connectionCodeStudent,
      firstName: data.firstName,
      fullName: data.accountName,
    }];
  }
  const userList = getUserList();

  function renderPages() {
    switch (recipient) {
      case 'parent':
        return <ParentTemplate users={userList} language={language} />;
      case 'employee':
        return <EmployeeTemplate users={userList} language={language} />;
      case 'student':
        return <StudentTemplate users={userList} language={language} />;
      default:
        return <Alert variant="warning">Not implemented yet</Alert>;
    }
  }

  const handleHide = () => {
    window.location.hash = '';
  };
  return (
    <Wrapper show size="lg" onHide={handleHide}>
      <GlobalPrintStyle />
      <Modal.Header className="d-print-none align-items-start" closeButton>
        <Alert variant="info" className="mx-5 mb-0 d-flex form-text align-items-start">
          <FormattedMessage {...messages.intro} values={{ ...intlBreak, count: userList.length }} />
          <PrintButton />
        </Alert>
      </Modal.Header>
      <Modal.Body className="px-4 pt-0">
        {renderPages()}
      </Modal.Body>
    </Wrapper>
  );
}

PrintPage.propTypes = {
};

export default PrintPage;
